import { Box, Icon } from "@chakra-ui/react"
import {
	LinkedinShareButton,
	TwitterShareButton,
} from "react-share";

const Share = ({ url, title }) => {

	return (
		<Box>
			<Box marginBottom="8px">
				Share via:
			</Box>
			<Box display="flex" gap="8px">
				<LinkedinShareButton
					key="linkedin"
					url={url}
					resetButtonStyle={false}
					title={title}
				>
					<Icon height="48px" width="48px" viewBox="0 0 48 48" color="#000" fill="none" _hover={{color: "#0D1418"}} transitionProperty="color" transitionDuration="150ms" transitionTimingFunction="cubic-bezier(0.4, 0, 0.2, 1)">
            <path d="M48 0H9.6L0 9.33818V48H38.4L48 38.6618V0ZM16.2327 37.7891H10.2109V15.7964H16.2327V37.7891ZM13.2655 13.2655C11.3455 13.2655 9.77455 11.6945 9.77455 9.77455C9.77455 7.85455 11.3455 6.28364 13.2655 6.28364C15.1855 6.28364 16.7564 7.85455 16.7564 9.77455C16.7564 11.6945 15.1855 13.2655 13.2655 13.2655ZM40.2327 37.7891H34.2109V26.6182C34.2109 19.8982 26.1818 20.4218 26.1818 26.6182V37.7891H20.16V15.7964H26.1818V19.2873C28.9745 14.1382 40.1455 13.7018 40.1455 24.2618V37.7891H40.2327Z" fill="#111111"/>
					</Icon>
				</LinkedinShareButton>
				<TwitterShareButton
					key="twitter"
					url={url}
					resetButtonStyle={false}
					title={title}
				>
					<Icon height="48px" width="48px" viewBox="0 0 48 48" color="#000" fill="none" _hover={{color: "#0D1418"}} transitionProperty="color" transitionDuration="150ms" transitionTimingFunction="cubic-bezier(0.4, 0, 0.2, 1)">
            <g clip-path="url(#clip0_387_12011)">
            <path d="M24.9665 21.6431L17.5484 11.2577H13.6211L22.7847 24.174L23.9193 25.7449L31.8611 36.8286H35.7884L26.1011 23.3013L24.9665 21.6431Z" fill="#111111"/>
            <path d="M10.3031 0L0.703125 9.33818V48H39.1031L48.7031 38.6618V0H10.3031ZM30.6377 38.6618L22.6959 27.3164L12.7468 38.6618H10.1286L21.5613 25.6582L10.0413 9.33818H18.7686L26.3613 20.0727L35.7868 9.33818H38.4049L27.4959 21.7309L39.3649 38.5745H30.6377V38.6618Z" fill="#111111"/>
            </g>
            <defs>
            <clipPath id="clip0_387_12011">
            <rect width="48" height="48" fill="white" transform="translate(0.328125)"/>
            </clipPath>
            </defs>
					</Icon>
				</TwitterShareButton>
			</Box>
		</Box>
	);
};

export default Share;
